
const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="wrap">
                <p>&copy; {new Date().getFullYear()} Yazoo Bayou Apartments</p>
                <p>611 Sarrazin Ave, Pascagoula, MS 39567</p>
                <p><a href="tel:+12287623874">228.762.3874</a></p>
            </div>
        </footer>
    );
};

export default Footer;
